import React from 'react'
import ReactDOM from 'react-dom'
import ConsentBanner from 'consent_banner/consent_banner.jsx'

function mountBanner() {
  const mount = document.getElementById('consent-banner-root')
  if (mount) {
    ReactDOM.render(<ConsentBanner />, mount)
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountBanner)
} else {
  mountBanner()
}
